import { Divider } from '@dealstack/frontend/shared/components/fundament/Divider/Divider';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Text } from '@mantine/core';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	tabSectionName: string;
}

const HeaderBar = ({ className, tabSectionName }: Props) => {
	return (
		<div className={className}>
			<Text size="B5Bold" c={defaultTheme.v2.color.neutral[1200]}>
				{tabSectionName}
			</Text>
			<SectionTitleDivider />
		</div>
	);
};

const SectionTitleDivider = styled(Divider)`
	background-color: ${({ theme }) => theme.v3.colors.gray[2]};
	margin-top: 1em;
	margin-bottom: 2em;
`;
const Memoized = memo(HeaderBar);
const Styled = styled(Memoized)``;

export { Styled as HeaderBar };
